import { ExpenseType } from '@/api/contracts/models'
import dayjs from 'dayjs'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

export function useParams() {
  const router = useRouter()
  const budgetId = computed(
    () => router.currentRoute.value.params.budgetId as string,
  )
  const periodKey = computed(
    () =>
      (router.currentRoute.value.params.periodKey as string) ??
      dayjs().toDate().toPeriodKey(),
  )
  const categoryGroupId = computed(
    () => router.currentRoute.value.params.categoryGroupId as string,
  )
  const categoryId = computed(
    () => router.currentRoute.value.params.categoryId as string,
  )
  const transactionId = computed(
    () => router.currentRoute.value.params.transactionId as string,
  )
  const expenseType = computed(
    () => router.currentRoute.value.params.expenseType as ExpenseType,
  )

  const onboardingProgress = computed(
    () => router.currentRoute.value.params.onboardingProgress as string,
  )

  const transactionTemplateId = computed(
    () => router.currentRoute.value.params.transactionTemplateId as string,
  )

  const templateDate = computed(
    () => router.currentRoute.value.params.templateDate as string,
  )

  const bankAccountId = computed(
    () => router.currentRoute.value.params.bankAccountId as string,
  )

  const loanId = computed(
    () => router.currentRoute.value.params.loanId as string,
  )

  const bankConnectionId = computed(
    () => router.currentRoute.value.params.bankConnectionId as string,
  )

  const transactionSideId = computed(
    () => router.currentRoute.value.params.transactionSideId as string,
  )

  return {
    budgetId,
    periodKey,
    categoryId,
    categoryGroupId,
    transactionId,
    expenseType,
    onboardingProgress,
    transactionTemplateId,
    templateDate,
    bankAccountId,
    loanId,
    bankConnectionId,
    transactionSideId,
  }
}
